export default __webpack_public_path__ + "static/media/banner-03.8563ec58.jpeg";